<div class="flex h-14 justify-start p-3 md:hidden">
  <app-button
    theme="transparent"
    styleClass="h-8! text-text-default!"
    [icon]="true"
    (click)="toPrev.emit()">
    <ic-arrow-left-outline class="block h-5 w-5" />
  </app-button>
</div>
<div class="mx-auto max-w-sm space-y-6 p-6 md:py-40">
  <div class="space-y-2 text-center">
    <p class="text-text-default text-xl font-bold">Verifikasi OTP</p>
    <p class="text-text-default text-sm">Kode OTP Berhasil dikirim ke E-Mail</p>
    <div class="bg-surface-low mx-auto flex w-max items-center gap-1.5 rounded-full px-2 py-1.5">
      <ic-email-outline class="block h-4.5 w-4.5" />
      <p class="text-text-default text-sm leading-0">{{ email() || "[EMAIL_ADDRESS]" }}</p>
    </div>
  </div>
  <form
    class="mx-auto w-max space-y-2"
    [formGroup]="form">
    <p-inputotp
      class="mx-auto w-max"
      formControlName="otp"
      [length]="OTP_LENGTH"
      [integerOnly]="true"
      [disabled]="formSubmitting()"
      (ngModelChange)="onOtpChange()">
      <ng-template
        #input
        let-token
        let-events="events">
        <input
          pInputText
          type="text"
          class="text-text-brand border-line-default focus:border-line-brand h-10.5 w-10.5 rounded-xl border bg-transparent text-center text-3xl font-bold transition"
          [ngClass]="{
            'text-text-danger! border-line-error!': formError.otp.msg,
          }"
          inputmode="numeric"
          pattern="[0-9]*"
          (input)="events.input($event)"
          (keydown)="events.keydown($event)"
          (paste)="onOtpPasted($event)"
          [attr.value]="token"
          [maxLength]="1" />
      </ng-template>
    </p-inputotp>
    @if (formError.otp.msg) {
      <p class="text-text-error bg-bg-tint-error-subtlest px-2 py-1 text-center text-xs">
        {{ formError.otp.msg }}
      </p>
    }
  </form>
  @if (countdown.countdown$) {
    <p class="text-text-subtle text-center text-xs">
      Mohon tunggu dalam
      <strong class="text-text-brand">{{ countdownSecond() }} detik</strong>
      untuk meminta <br />
      OTP baru
    </p>
  } @else {
    <app-button
      theme="tint-brand"
      styleClass="h-8! w-max! mx-auto text-xs font-normal! text-text-brand!"
      [disabled]="formSubmitting()"
      (click)="_onReRequestOtp()">
      Kirim ulang Kode OTP
    </app-button>
  }
</div>
